/* eslint-disable camelcase */
import moment from 'moment'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

import { REPORT_TABLE_TYPES } from 'Components/UI/EAReport/constants'

import summaryReportData from 'Components/UI/EAReport/Table/Summary/utils/summaryReportData'

pdfMake.vfs = pdfFonts.pdfMake.vfs

const exportToPDF = ({
  columns,
  dataSource,
  filtrosDetalhados,
  reportName,
  title,
  exportDetails = false
}) => {
  const detailColumnDef = columns.find((col) => col.columns)
  const mainColumns = columns.filter(
    (col) =>
      (!col.columns || col.columns.length === 0) && col.exportable !== false
  )

  let detailColumns = []
  if (detailColumnDef) {
    detailColumns = detailColumnDef.columns.filter(
      (col) => col.exportable !== false
    )
  }

  const reportTimeStamp = moment().format('DD_MM_YYYY_HH_mm_ss')
  const metadataContent = [
    { bold: true, text: `EasyAssist Web - ${title}` },
    ...(Array.isArray(filtrosDetalhados)
      ? filtrosDetalhados.map((detalhe) => ({ text: detalhe }))
      : []),
    {
      margin: [0, 0, 0, 20],
      text: `Gerado em: ${moment().format('DD/MM/YYYY HH:mm:ss')}`
    }
  ]

  let mainTableDefinition
  let summaryData = []
  const hasSummary = mainColumns.some((column) => column.summary === true)
  const totalColumnsCount = mainColumns.length

  const formatCellValue = (dataIndex, type, record) => {
    if (REPORT_TABLE_TYPES.includes(type)) {
      return record[`${dataIndex}_str`]
    }

    return record[dataIndex]
  }

  if (!exportDetails) {
    const header = mainColumns.map((column) => {
      const { align = 'left', title: columnTitle } = column
      return {
        alignment: align,
        bold: true,
        fillColor: '#ddd',
        text: columnTitle
      }
    })

    const body = dataSource.map((record) =>
      mainColumns.map((column) => {
        const { align = 'left', dataIndex, type } = column
        const value = formatCellValue(dataIndex, type, record)
        return { alignment: align, text: value }
      })
    )

    const tableBody = [header, ...body]

    if (hasSummary) {
      summaryData = summaryReportData(mainColumns, dataSource).map((column) => {
        const { align, total_str } = column
        return {
          alignment: align,
          bold: true,
          fillColor: '#ddd',
          text: total_str
        }
      })
    }

    mainTableDefinition = {
      table: {
        body: hasSummary
          ? [
              ...tableBody,
              [
                {
                  bold: true,
                  colSpan: totalColumnsCount,
                  fillColor: '#ddd',
                  text: 'Total'
                }
              ],
              summaryData
            ]
          : tableBody,
        headerRows: 1,
        widths: mainColumns.map(() => (mainColumns.length > 6 ? 'auto' : '*'))
      }
    }
  } else {
    mainTableDefinition = []

    const mainColumnWidths = mainColumns.map(() =>
      mainColumns.length > 6 ? 'auto' : '*'
    )
    const hasSummaryDetails = detailColumns.some(
      (column) => column.summary === true
    )

    dataSource.forEach((record, index) => {
      const details = record.detalhes || []
      const detailsLayout = {
        hLineWidth() {
          return 0.2
        },
        vLineWidth() {
          return 0.2
        },
        hLineColor() {
          return '#aaa'
        },
        vLineColor() {
          return '#aaa'
        }
      }

      const mainRowCells = mainColumns.map((column) => {
        const { align = 'left', dataIndex, type, title: columnTitle } = column
        const value = `${columnTitle}: ${
          formatCellValue(dataIndex, type, record) || ''
        }`

        return {
          alignment: align,
          text: value,
          bold: true,
          fillColor: '#f0f0f0'
        }
      })

      mainTableDefinition.push({
        table: {
          body: [mainRowCells],
          headerRows: 0,
          widths: mainColumnWidths
        },
        layout: detailsLayout,
        margin: [0, index === 0 ? 0 : 15, 0, 0]
      })

      if (details.length > 0) {
        const detailHeader = detailColumns.map((column) => {
          const { align = 'left', title: columnTitle } = column
          return {
            alignment: align,
            bold: true,
            fillColor: '#ddd',
            text: columnTitle,
            fontSize: 8
          }
        })

        const detailBody = details.map((detailRecord) =>
          detailColumns.map((column) => {
            const { align = 'left', dataIndex, type } = column
            const value = formatCellValue(dataIndex, type, detailRecord)

            return {
              alignment: align,
              text: value,
              fontSize: 8
            }
          })
        )

        const summaryDetails = summaryReportData(
          detailColumns,
          record.detalhes
        ).map((column) => {
          const { align, total_str } = column

          return {
            alignment: align,
            bold: true,
            fillColor: '#ddd',
            text: total_str
          }
        })

        mainTableDefinition.push({
          table: {
            body: hasSummaryDetails
              ? [
                  detailHeader,
                  ...detailBody,
                  [
                    {
                      bold: true,
                      colSpan: detailColumns.length,
                      fillColor: '#ddd',
                      text: 'Total'
                    }
                  ],
                  summaryDetails
                ]
              : [detailHeader, ...detailBody],
            headerRows: 1,
            widths: detailColumns.map(() =>
              detailColumns.length > 6 ? 'auto' : '*'
            )
          },
          layout: detailsLayout,
          margin: [20, 5, 0, 0]
        })
      }
    })

    if (hasSummary) {
      const summary = summaryReportData(mainColumns, dataSource).map(
        (column) => {
          const { align, total_str } = column
          return {
            alignment: align,
            bold: true,
            fillColor: '#ddd',
            text: total_str
          }
        }
      )

      const totalLabel = [
        {
          bold: true,
          colSpan: mainColumns.length,
          fillColor: '#ddd',
          text: 'Total'
        }
      ]

      mainTableDefinition.push({
        table: {
          body: [totalLabel, summary],
          headerRows: 0,
          widths: mainColumnWidths
        },
        margin: [0, 20, 0, 0]
      })
    }
  }

  const finalContent = [
    ...metadataContent,
    ...(Array.isArray(mainTableDefinition)
      ? mainTableDefinition
      : [mainTableDefinition])
  ]

  pdfMake
    .createPdf({
      content: finalContent,
      defaultStyle: {
        fontSize: 10
      },
      pageOrientation: 'landscape'
    })
    .download(`relatorio_${reportName}_${reportTimeStamp}`)
}

export default exportToPDF
